import { Avatar, Button, Card, Select } from "antd";
import { useEffect, useState } from "react";
import Layout, { Breadcrumb, Container } from "../../components/layout";
import { useAppState } from "../../context";

const { Option } = Select;

const FocusMember = () => {
  const [selectedMembers, setSelectedMembers] = useState<string[]>([]);

  const { getAllMember, allFocusMemberData, updateFocusMember } =
    useAppState("focusMember");
  const { currentWeekData, getCurrentWeek } = useAppState("teammember");

  // Fetch initial data once
  const fetchInitialData = async () => {
    await getCurrentWeek();
    await getAllMember(currentWeekData?._id);
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  // Pre-select members with roleName "Focus Member"
  useEffect(() => {
    const preSelected = allFocusMemberData
      ?.filter((member: any) => member.roleName === "Focus Member")
      ?.map((member: any) => member._id);
    setSelectedMembers(preSelected || []);
  }, [allFocusMemberData]);

  // Handle dropdown selection change
  const handleSelectChange = (value: string[]) => {
    // if (value.length <= 4) {
    setSelectedMembers(value);
    // }
  };

  // Handle submit
  const handleSubmit = async () => {
    try {
      const success = await updateFocusMember(
        currentWeekData._id,
        selectedMembers,
      );

      if (success) {
        await getAllMember(currentWeekData?._id); // Refresh the data only on successful update
      }
    } catch (error) {
      console.error("Failed to update focus members:", error);
    }
  };

  return (
    <Layout>
      <Breadcrumb title="Focus Member" />
      <Container>
        {/* Dropdown for member selection */}
        <div className="mb-4">
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select up to 4 members"
            value={selectedMembers}
            onChange={handleSelectChange}
            // maxTagCount={4}
            optionFilterProp="children"
          >
            {allFocusMemberData.map((member: any) => (
              <Option key={member._id} value={member._id}>
                {member.name}
              </Option>
            ))}
          </Select>
        </div>

        {/* Submit button */}
        <Button
          type="primary"
          onClick={handleSubmit}
          // disabled={selectedMembers.length === 0}
          className="mb-6"
        >
          Submit
        </Button>

        {/* Display Focus Members */}
        <div className="mt-6">
          <h3
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginBottom: "1rem",
            }}
          >
            Focus Members:
          </h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "1rem",
            }}
          >
            {allFocusMemberData
              ?.filter((member: any) => member.roleName === "Focus Member")
              ?.map((member: any) => (
                <Card
                  key={member._id}
                  hoverable
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    padding: "1rem",
                  }}
                >
                  <Card.Meta
                    avatar={<Avatar size="large">{member.name[0]}</Avatar>}
                    title={
                      <span style={{ fontWeight: "bold" }}>{member.name}</span>
                    }
                    description={
                      <span style={{ color: "rgba(0,0,0,0.6)" }}>
                        {member.roleName}
                      </span>
                    }
                  />
                </Card>
              ))}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default FocusMember;
